import Estimate from "./Estimate";
import EstimateStatus from "./EstimateStatus";
import BaseModel from "./BaseModel";

export default class EstimateStatusLog extends BaseModel {

	static entity = 'estimate_status_logs';
	static route = 'estimate-status-logs';
	static plural = 'estimate_status_logs';
	static singular = 'estimate_status_log';

	static fields () {
		return {
			id: this.attr(null), 
			estimate_id: this.attr(null),
			estimate: this.belongsTo(Estimate, 'estimate_id'),
			estimate_status_id: this.attr(null),
			estimate_status: this.belongsTo(EstimateStatus, 'estimate_status_id'),
			created_at: this.attr(null), 
			updated_at: this.attr(null), 
			deleted_at: this.attr(null)
		}
	}

	static configureApi() {
		let config = super.configureApi();
		config.actions.export = function(id) {
			return this.post('/'+EstimateStatusLog.route+'/'+id+'/export', {
				dataTransformer: (response) => {
					return EstimateStatusLog.transformDefault(response, 'estimate_status_log');
				}
			});
		};
		return config;
	}

	static apiConfig = this.configureApi();

}
